import { render, staticRenderFns } from "./quoteList.vue?vue&type=template&id=2bb075c6&scoped=true"
import script from "./quoteList.vue?vue&type=script&lang=js"
export * from "./quoteList.vue?vue&type=script&lang=js"
import style0 from "./quoteList.vue?vue&type=style&index=0&id=2bb075c6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb075c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bb075c6')) {
      api.createRecord('2bb075c6', component.options)
    } else {
      api.reload('2bb075c6', component.options)
    }
    module.hot.accept("./quoteList.vue?vue&type=template&id=2bb075c6&scoped=true", function () {
      api.rerender('2bb075c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/order/inquiry/quoteList.vue"
export default component.exports